import styled from 'styled-components';
import themeColors, { baseColors } from 'styles/config/colors';
import themeSpacing from 'styles/config/spacing';

import { KeyboardSafeInput } from 'components/atoms/KeyboardSafeInputs';
import { Body } from 'components/atoms/LegacyText';

export const TagInputWrapper = styled.div<{ $isError?: boolean }>`
  display: flex;
  flex-wrap: wrap;
  gap: ${themeSpacing.xs3};

  width: 100%;
  padding: ${themeSpacing.xs3};

  border: 1px solid
    ${({ $isError }) => ($isError ? baseColors.red['20'] : themeColors.borderStrong)};
  border-radius: ${themeSpacing.radiusXSmall};
`;

export const TagInput = styled(KeyboardSafeInput)`
  width: 100%;
  height: 20px;
  padding-left: ${themeSpacing.xxs2};

  font-size: ${({ theme }) => theme.text.size.body.regular};
  font-weight: ${({ theme }) => theme.text.weight.bold};
`;

export const ErrorMessage = styled(Body)`
  font-size: ${({ theme }) => theme.text.size.body.small};
  font-weight: ${({ theme }) => theme.text.weight.semibold};
  color: ${themeColors.errorText01};
`;

export const DropdownWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const Dropdown = styled.div`
  position: absolute;
  z-index: 1000;
  top: 100%;
  right: 0;
  left: 0;

  overflow-y: auto;

  max-height: 200px;

  background: ${themeColors.background};
  border: 1px solid ${themeColors.borderStrong};
  border-top: none;
  border-radius: 0 0 ${themeSpacing.radiusXSmall} ${themeSpacing.radiusXSmall};
`;

export const DropdownOption = styled.div<{ $isSelected?: boolean }>`
  cursor: pointer;
  padding: ${themeSpacing.xs2} ${themeSpacing.xs3};
  font-size: ${({ theme }) => theme.text.size.body.regular};
  background-color: ${({ $isSelected }) =>
    $isSelected ? themeColors.backgroundHover : 'transparent'};

  &:hover {
    background-color: ${themeColors.backgroundHover};
  }

  &:last-child {
    border-radius: 0 0 ${themeSpacing.radiusXSmall} ${themeSpacing.radiusXSmall};
  }
`;
